// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3effaa61","239":"cba09539","453":"7880b607","455":"9ad4fbc1"}[chunkId] + ".chunk.js";
};